module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"image":"Image","frame":"Frame"},"ja":{"image":"画像","frame":"領域枠"}}')
  delete Component.options._Ctor
}
